// extracted by mini-css-extract-plugin
var _1 = "HistoricalPost-module__animateUploadProgressBarWidth--R5u5x";
var _2 = "HistoricalPost-module__animatedBackground--JP1k8";
var _3 = "HistoricalPost-module__editorContainer--OVBZN";
var _4 = "HistoricalPost-module__editorRoot--I4gYJ";
var _5 = "HistoricalPost-module__historicalPost--fyf2P";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "editorContainer", _4 as "editorRoot", _5 as "historicalPost" }
